import React from 'react';

import { makeStyles } from 'tss-react/mui';

import { Typography } from '@hbf/dsl/core';

const useListingCardDetailsAttributesStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.utils.spacing('ref/spacing/2'),
    width: '100%',
    maxHeight: theme.utils.dimension('ref/dimension/6'),
    overflow: 'hidden',
  },
  separator: {
    flexShrink: 0,
  },
}));

interface ListingCardDetailsAttributesProps {
  children: React.ReactNode;
}

export const ListingCardDetailsAttributes = ({
  children,
}: ListingCardDetailsAttributesProps) => {
  const { classes } = useListingCardDetailsAttributesStyles();

  const items = React.Children.toArray(children).filter(Boolean);

  return (
    <div className={classes.container}>
      {items.map((child, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          {index > 0 && (
            <Typography
              variant="caption/semibold"
              className={classes.separator}
              aria-hidden
            >
              •
            </Typography>
          )}
          {child}
        </React.Fragment>
      ))}
    </div>
  );
};

const useListingCardDetailsAttributeStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.utils.spacing('ref/spacing/1'),
    overflow: 'hidden',
    flexShrink: 0,
  },
  icon: {
    display: 'flex',
    svg: {
      fontSize: '20px',
    },
  },
  label: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

interface ListingCardDetailsAttributeProps {
  slots: {
    icon: React.JSXElementConstructor<{ size?: 'sm' | 'md' }> | null;
    label: string;
  };
  'data-test-locator'?: string;
}

export const ListingCardDetailsAttribute = ({
  slots,
  'data-test-locator': dataTestLocator,
}: ListingCardDetailsAttributeProps) => {
  const { classes } = useListingCardDetailsAttributeStyles();

  return (
    <div
      className={classes.container}
      title={slots.label}
      data-test-locator={dataTestLocator}
    >
      {slots.icon && (
        <div className={classes.icon}>
          <slots.icon size="md" />
        </div>
      )}
      <Typography variant="body/sm-regular" className={classes.label}>
        {slots.label}
      </Typography>
    </div>
  );
};
